import { Agent } from '../../../types/agent';
import { getAgentVisuals } from '../utils/agentVisuals';

interface AgentAvatarProps {
  agent: Pick<Agent, 'id' | 'name'>;
  size?: number;
}

export const AgentAvatar = ({ agent, size = 24 }: AgentAvatarProps) => {
  const { initial, bg, fg } = getAgentVisuals(agent);
  return (
    <div
      className="rounded-lg flex items-center justify-center font-bold flex-shrink-0"
      style={{ width: size, height: size, background: bg, color: fg, fontSize: size * 0.42 }}
    >
      {initial}
    </div>
  );
};
